/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetChecklistItemRequest
 */
export interface SetChecklistItemRequest {
    /**
     * 
     * @type {string}
     * @memberof SetChecklistItemRequest
     */
    shipmentId: string;
    /**
     * 
     * @type {string}
     * @memberof SetChecklistItemRequest
     */
    checklistKey: string;
    /**
     * 
     * @type {boolean}
     * @memberof SetChecklistItemRequest
     */
    checked: boolean;
    /**
     * The step was deliberately passed over rather than done. Only meaningful alongside checked=true — both move the list on, but a skipped step is drawn neutrally rather than with a tick. Absent means not skipped.
     * @type {boolean}
     * @memberof SetChecklistItemRequest
     */
    skipped?: boolean;
}

/**
 * Check if a given object implements the SetChecklistItemRequest interface.
 */
export function instanceOfSetChecklistItemRequest(value: object): value is SetChecklistItemRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    if (!('checklistKey' in value) || value['checklistKey'] === undefined) return false;
    if (!('checked' in value) || value['checked'] === undefined) return false;
    return true;
}

export function SetChecklistItemRequestFromJSON(json: any): SetChecklistItemRequest {
    return SetChecklistItemRequestFromJSONTyped(json, false);
}

export function SetChecklistItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetChecklistItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
        'checklistKey': json['checklistKey'],
        'checked': json['checked'],
        'skipped': json['skipped'] == null ? undefined : json['skipped'],
    };
}

  export function SetChecklistItemRequestToJSON(json: any): SetChecklistItemRequest {
      return SetChecklistItemRequestToJSONTyped(json, false);
  }

  export function SetChecklistItemRequestToJSONTyped(value?: SetChecklistItemRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
        'checklistKey': value['checklistKey'],
        'checked': value['checked'],
        'skipped': value['skipped'],
    };
}

